import React from 'react';
import { number, string, object } from 'prop-types';

import classnames from 'classnames';

import RenderStars from './components/render-stars';
import { namespace } from './constants';

/**
 * ReviewSummary component
 *
 * @param {Object} props - Component properties
 * @param {string} props.accesibilityText - Text for screen readers
 * @param {string} [props.className] - Additional class names for the component
 * @param {Object} props.formattedAverage - Formatted average rating object
 * @param {Object} props.formattedTotal - Formatted total reviews object
 * @param {number} [props.rating] - Rating value
 * @param {Object} props.stars - Stars object
 */
const ReviewSummary = ({ className = '', rating = 4.5, stars, formattedTotal, formattedAverage, accesibilityText }) => (
  <div className={classnames(namespace, className)}>
    <span className="andes-visually-hidden">{accesibilityText}</span>
    <span className={`${namespace}__rating-number`} aria-hidden>
      {formattedAverage?.text ? formattedAverage.text : formattedAverage}
    </span>
    <span className={`${namespace}__ratings`} aria-hidden>
      <RenderStars stars={stars} rating={rating} />
    </span>
    <span className={`${namespace}__amount`} aria-hidden>
      {formattedTotal?.text ? formattedTotal.text : formattedTotal}
    </span>
  </div>
);

ReviewSummary.propTypes = {
  accesibilityText: string.isRequired,
  className: string,
  formattedAverage: object.isRequired,
  formattedTotal: object.isRequired,
  rating: number,
  stars: object.isRequired,
};

export default ReviewSummary;
